const wrapper = {
    display: 'flex',
    gap: {
        mobile: '16px',
        desktop: '24px',
    },
    flexDirection: 'column',
    padding: {
        mobile: '24px',
        desktop: '40px',
    },
    '& > .MuiTypography-root': {
        marginLeft: {
            mobile: '0',
            desktop: '42px',
        },
    },
};
const card = {
    '& > .progress-card-container': {
        display: 'grid',
        //Removed the space between the date pill, card title, card description
        //gap: '10px',
        gridTemplateRows: 'auto',
        gridTemplateColumns: {
            desktop: '19fr 4fr 39fr 36fr',
            mobile: 'auto',
        },
        gridTemplateAreas: {
            desktop: `"pill b body info"
                "title b progress progress"
                "link b . ."`,
            mobile: `"pill ."
                    "title title"
                    "body body"
                    "progress progress"
                    "info info"
                    "link link"`,
        },
        height: '100%',
    },
    '& .MuiTypography-root': {
        lineHeight: '25px',
    },
};
const timeLeftInfo = {
    alignItems: 'center',
    justifyItems: 'center',
    color: 'info.dark',
    display: 'flex',
    justifyContent: 'left',
    pl: 0,
    gridArea: 'info',
};
const detailsLink = {
    alignItems: 'center',
    color: 'info.main',
    display: 'flex',
    gridArea: 'link',
};
export default {
    wrapper,
    card,
    timeLeftInfo,
    detailsLink,
};
